<template>
  <div>
    <div>
      <div style="display: flex;flex-direction: row;justify-content: space-between;">
        <div>
          <el-button size="mini" @click="addUser">添加</el-button>
<!--          <el-button size="mini" @click="retConfig({})">重置</el-button>-->
        </div>
        <div>
          <div style="color: #ff3d00"> 催费任务户数 = （ 小区域数 * 15 + 项目数 *5 ） </div>
          <div style="color: #ff3d00"> 抽检任务户数 = 催费任务户数 * 抽检百分比 </div>
        </div>
      </div>
      <div class="table-wrap">
        <el-table
          v-loading="loading"
          :data="pageData.list"
          border
          style="width: 100%">
          <el-table-column
            prop="project_name_str"
            label="项目"
            width="180">
            <template slot-scope="scope">
              <el-tooltip effect="dark" :content="scope.row['project_name_str']" placement="bottom">
                <span class="project-name">{{scope.row['project_name_str']}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="姓名"
            width="180">
          </el-table-column>
          <el-table-column
            prop="position_name"
            label="职位"
            width="180">
          </el-table-column>
          <el-table-column
            prop="user_level"
            label="等级"
            width="180">
            <template slot-scope="scope">
              <el-select v-model="scope.row.user_level" class="m-2" style="width: 100%;" filterable placeholder="选择项目" clearable size="small" @change="saveConfig(scope.row)">
                <el-option
                  v-for="item in user_level_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="project_count"
            label="管辖项目数"
            width="150">
            <template slot-scope="scope">
              <input class="table-input" v-model="scope.row.project_count" @input="computedItem(scope.row)" @change="saveConfig(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="area_count"
            label="管辖小区域数"
            width="150">
            <template slot-scope="scope">
              <input class="table-input" v-model="scope.row.area_count" @input="computedItem(scope.row)" @change="saveConfig(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="all_count"
            label="催费任务户数"
            width="150"></el-table-column>
          <el-table-column
            prop="task_rate"
            label="抽检百分比"
            width="150">
            <template slot-scope="scope">
              <input class="table-input" v-model="scope.row.task_rate" @input="computedItem(scope.row)" @change="saveConfig(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="task_count"
            label="抽检任务户数"
            width="150">
          </el-table-column>
          <el-table-column
            prop="remarks"
            label="备注"
            width="200">
            <template slot-scope="scope">
              <input class="table-input" v-model="scope.row.remarks" @change="saveConfig(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            label="操作" width="250">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="saveConfig(scope.row)">保存</el-button>
              <el-button size="mini" @click="retConfig(scope.row)">重置</el-button>
              <el-button type="danger" size="mini" @click="delItem(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
         :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
         @current-change="pageChange"></el-pagination>
      </div>
    </div>
    <selectPersonnel ref="selectPersonnel" />
  </div>
</template>

<script>
import Track from "../../../../../assets/js/trackHttp";
import moment from "moment";
import selectPersonnel from "../../../Personnel/components/selectPersonnel";

export default {
  name: "LegalTaskConfigList",
  inject:['where','reginWhere'],
  components:{selectPersonnel},
  data(){
    return{
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      all_count:0,
      from_data:{},
      dialogVisible:false,
      tree_obj:null,
      loading: false,
      user_level_list:[{id:1,name:"战区"},{id:2,name:"片区"},{id:3,name:"项目"},{id:4,name:"小区域"}]
    }
  },
  mounted() {
    this.getList()
    // this.getAjaxCount()
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.pageChange(1);
    },
    "reginWhere.project_region":function (n,o) {
      this.pageChange(1);
    },
    "reginWhere.project_name":function (n,o) {
      this.pageChange(1);
    },
    "where.day_time":function (n,o) {
      this.pageChange(1);
    },
    "where.start_time":function (n,o) {
      this.pageChange(1);
    },
    "where.user_name":function (n,o) {
      this.pageChange(1);
    },
    "where.position_id":function (n,o) {
      this.pageChange(1);
    },
  },
  methods:{
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      // let where = ERP.reJson(that.where);
      let start_time = that.reginWhere.start_time ?  that.reginWhere.start_time : moment(new Date()).format("YYYYMMDD");
      let end_time = that.reginWhere.end_time ?  that.reginWhere.end_time : moment(new Date()).format("YYYYMMDD");
      let where = {
        ...that.where,
        project_ids:that.reginWhere.project_ids,
        project_regin: that.reginWhere.project_region,
        project_id:that.reginWhere.project_name,
        project_type:that.reginWhere.type_id,
      }

      // console.log('where', where);

      // 请求
      Track.post('logger/UserTaskConfig/getList', {...where, page: that.pageData.page,page_size: that.pageData.pageSize}, res => {
        that.loading = false;
        // console.log('请求结果', res);
        if (res.code) {
          that.pageData  = res.data;
        }
      })
      //
    },
    computedItem(item){
      item.all_count=item.area_count*15 + item.project_count*5
      item.task_count=Math.round(item.all_count*item.task_rate)
    },
    retConfig(item){
      const that=this;
      that.$confirm('请确认是否重置当前，重置后将依据权限分配来默认！', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading = true;
        Track.post('logger/UserTaskConfig/initTaskConfig', {
          group_name:"抽检记录",
          project_type:that.reginWhere.type_id,
          user_ids:item.user_id||"",
        }, res => {
          that.loading = false;
          if (res.code) {
            that.$message.success('保存成功');
            that.getList();
          }else {
            that.$message.success('保存失败');
          }
        })
      }).catch(() => {

      });

    },
    saveConfig(item){
      const that=this;
      that.loading = true;
      Track.post('logger/UserTaskConfig/setTaskConfig', {...item}, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success('保存成功');
          item  = res.data;
        }else {
          that.$message.success('保存失败');
        }
      })
    },
    delItem(item){
      const that=this;
      that.$confirm('确认是否删除？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Track.post('logger/UserTaskConfig/delTaskConfig', {id:item.id}, res => {
          if (res.code) {
            that.getList()
          }else {
            that.$message.success('保存失败');
          }
        })
      }).catch(() => {

      });
    },
    addUser(){
      const that=this;
      that.$refs.selectPersonnel.show({},user_list=>{
        if(user_list.length){
          that.$confirm('是否确定添加该人员？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let user_ids=user_list.map(ret=>ret.id);
            that.addUserTask(user_ids.join(','))
          }).catch(() => {

          });
        }
      })
    },
    addUserTask(user_ids){
      const that=this;
      Track.post('logger/UserTaskConfig/addUserTaskConfig', {
        group_name:"抽检记录",
        project_type:that.reginWhere.type_id,
        user_ids:user_ids,
      }, res => {
        if (res.code) {
          that.getList()
        }else {
          that.$message.success(res.msg||'失败');
        }
      })
    }
  },

}
</script>

<style lang="scss" scoped>
@import "../../common";

.m-2{
  width: 150px;
}
.ti {
  margin: 1%;
  width: 98%;
}

.text1 {
  text-align: center;
}

.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}

.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}

.text2 {
  color: rgb(250, 248, 248);
}

.kuan {
  width: 10%;
}

.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  margin: 30px;
  width: calc( 100% - 10px );
  overflow-y: scroll;
  height: calc( 100vh - 150px );

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }

  .btn-item {
    margin-top: 10px;
    margin-right: 30px;
  }

  >>>.el-tabs__item{
    color: black;
  }
}
.view-file-win{
  height: 60vh;
  overflow-y: scroll;
  .main-log{
    margin: 10px 20px;
  }
}
.header-btn2{
  .btn-item{
    margin: 10px 20px;
  }
}
.pagination-wrap {
  text-align: center;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 15px;
  display: flex;
}
.project-name{
  width: 150px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table-input{
  background-color: #ffebc6;
  width: 100%;
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/task_config/LegalTaskConfigList.vue